import { app } from '../../../bootstrap/core';
import { addressFormularComponent } from './addressFormular.component';

app.component('addressFormular', addressFormularComponent);
